import React, { Component } from "react";
import LayoutOperation from "../../components/layout_operation";
import { DownOutlined, PlusOutlined, CopyOutlined } from "@ant-design/icons";
import axios from "axios";
import {
  Dropdown,
  Menu,
  Select,
  Radio,
  Upload,
  message,
  Checkbox,
  // Table,
  Badge,
  DatePicker,
  Modal,
  Image
} from "antd";
import Map from "../../ui/map/assign_job";
import Cookies from "js-cookie";
import { connect } from "react-redux";
import moment from "moment";
import ModalSuccess from "../../components/Modal_Success";
import Api from "../../services/ServiceApi";
import { changeLang } from "../../actions/langAction";
import { setDynamic } from "../../actions/dynamicAction";
// import { Link } from "react-router-dom";
const menu = (
  <Menu>
    <Menu.Item>Action 1</Menu.Item>
    <Menu.Item>Action 2</Menu.Item>
  </Menu>
);
const dateFormat = 'YYYY-MM-DD HH:mm:ss';
const { RangePicker } = DatePicker;
// const { Option } = Select;
class Editjob extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      period_start: [],
      period_end: [],
      loading: true,
      title:
        JSON.parse(localStorage.getItem("StatusLocal")) === 1
          ? "Edit Job Maintenance Job ID : " +
          JSON.parse(localStorage.getItem("editjob"))["job_no"]
          : "Create Job  Inform",
      statusbtn: 2,
      job_type: [],
      sub_type: [],
      get_preiod: [],
      startDate: new Date(),
      DateTime_Install: new Date(),
      Assign_date: new Date(),
      options: [],
      team_list: [],
      fileList: [],
      uploading: false,
      jobcategory: "",
      //jobtype: "",
      ckTeam: false,
      ckSingle: false,
      ckasset: false,
      form: {},
      Priority: 1,
      modalstatus: false,
      set_asset: [],
      asset_name: "-",
      group_type: "-",
      asset_type: "-",
      ass_sub_type: "-",
      modal_number: "-",
      serial_number: "-",
      date_install: "-",
      warranty: "-",
      asset_ma: "-",
      location_lat: "",
      location_lon: "",
      location_name: "-",
      ass_code: "-",
      smart_code: "-",
      ckpm: false,
      ckcm: false,
      status_button_workflow: "",
      status_cookie: 0,
      setStartDate: new Date(),
      columns_jobs: [
        { title: "Date", dataIndex: "date", key: "date" },
        { title: "Name", dataIndex: "name", key: "name" },
        {
          title: "Status",
          key: "state",
          render: () => (
            <span>
              <Badge status="success" />
              Finished
            </span>
          ),
        },
        { title: "Upgrade Status", dataIndex: "upgradeNum", key: "upgradeNum" },
        {
          title: "Action",
          dataIndex: "operation",
          key: "operation",
          render: () => (
            <span className="table-operation">
              <button className="c-blue text-underline">Pause</button>
              <button className="c-blue text-underline">Stop</button>
              <Dropdown overlay={menu}>
                <button className="c-blue text-underline">
                  More <DownOutlined />
                </button>
              </Dropdown>
            </span>
          ),
        },
      ],
      job_cat: [],
      active: 0,
      visibleView: false,
      dataMasFormJson_Call: {},
      data_dynamic_from: [],
      department_id: 0,
      id_form: 0,
      more_detail: false,
      selected_jobtype: null,
      selected_subtype: null,
      WorkFlow: {},
      factupdate: false,
      ObjectPart: [],
      serviceType: [],
      newType: [],
      subCategory: [],
      sla_level: [],
      previewVisible: false,
      previewImage: "",
      previewTitle: "",
      checkbtn: false,
      workflow_id: 0,
      data_mainttenance: [],
      sel_type: null,
      sel_new_type: null,
      sel_sub_cat: null,
      sel_sla: null,
      customs: {
        select_object_path: null,
        select_sel_type: null,
        select_new_type: null,
        select_sub_category: null,
      },
      inform_detail: "",
      data_local: [],
      urlpath: "",
      service_type_level_id: "",
      job_status: "",
      inform_name: Cookies.get("username"),
      fack_check: JSON.parse(localStorage.getItem("StatusLocal")),
      job_progress_id: "",
      job_sub_type_id: "",
      checkAssetType: false,
      plan_date: [],
      disabled_btn: true,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }
  async componentDidMount() {
    document.title = "MaxiOperation - " + this.state.title;
    this.setState({
      urlpath: process.env.REACT_APP_URL_API,
    });
    const dataLocal = JSON.parse(
      localStorage.getItem(
        JSON.parse(localStorage.getItem("StatusLocal")) === 1
          ? "editjob"
          : "informDetail"
      )
    );
    if (JSON.parse(localStorage.getItem("StatusLocal")) === 1) {
      this.setState({
        jobcategory: dataLocal.job_category_id,
        selected_jobtype: dataLocal.job_type_id,
      });
      const get_detail = await Api.post("get_one_job_detail", {
        i_select: null,
        job_status: null,
        category_id: null,
        select_date: null,
        job_type_id: null,
        prority_id: null,
        username: Cookies.get("username"),
        company_id: Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        sql_where: "and job_id =" + dataLocal.job_id,
      });
      const GetJobCategoty = await Api.post("get_job_category_V2", {
        company_id: Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        job_category_id: null,
        is_active: 1,
        date_active: 1,
        operator_id: Cookies.get("operator_id"),
      });
      const data_language = await Api.post("master_language_detail_get", {
        company_id: Cookies.get("companyid"),
        page_id: 1,
      });
      const get_cdi_new_smart = await Api.get(
        "get_cdi_new_smart",
        Cookies.get("companyid") +
        "/" +
        Cookies.get("operator_id") +
        "/" +
        dataLocal.asset_id
      );
      const get_cdi_new_smart_master = await Api.get(
        "get_cdi_new_smart",
        Cookies.get("companyid") + "/" + Cookies.get("operator_id") + "/"
      );
      const get_ma_period = await Api.post("get_ma_period", {
        pk_id: "",
        is_active: "1",
        effective: "",
        sql_where: " and company_id=" + Cookies.get("companyid"),
      });
      const data_sub_type = await Api.post("get_job_sub_type", {
        job_sub_type_id: null,
        job_category_id: this.state.jobcategory,
        job_type_id: get_detail.data.data.result_job_list[0].job_type_id,
        is_active: 1,
        effective: 1,
        sql_where: " and company_id=" + Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
      });

      this.btnjobDetail(dataLocal.job_category_id);
      this.Setdata_jobtype(get_detail.data.data.result_job_list[0].job_type_id);
      if (dataLocal.asset_id != "-1") {
        this.onChangeasset(null, get_cdi_new_smart.data.data.data[0]);
      } else {
        this.setState({
          ckasset: true,
        });
      }
      this.state.form["inform_detail"] = dataLocal.inform_detail;
      this.state.form["ma_period_id"] =
        get_detail.data.data.result_job_list[0].ma_period_id;
      this.state.form["remark"] =
        get_detail.data.data.result_job_list[0].inform_remark;
      this.state.form["ma_period_id"] =
        get_detail.data.data.result_job_list[0].ma_period_id;
      this.state.form["inform_detail"] =
        get_detail.data.data.result_job_list[0].inform_detail;
      this.state.form["remark"] =
        get_detail.data.data.result_job_list[0].inform_remark;

      this.defaultSLA(
        get_detail.data.data.result_job_list[0].job_type_id,
        get_detail.data.data.result_job_list[0].service_type_level_id_1,
        get_detail.data.data.result_job_list[0].service_type_level_id_2,
        get_detail.data.data.result_job_list[0].service_type_level_id_3,
        get_detail.data.data.result_job_list[0].service_type_level_id_4,
        get_detail.data.data.result_job_list[0].service_type_level_id
      );

      this.state.plan_date.push(dataLocal.plan_start_date === null ? new Date() : dataLocal.plan_start_date);
      this.state.plan_date.push(dataLocal.plan_end_date === null ? new Date() : dataLocal.plan_end_date);
      this.setState({
        set_pic: get_detail.data.data.result_job_pic,
        customs: {
          select_object_path:
            get_detail.data.data.result_job_list[0].service_type_level_id_1 +
            "000000",
        },
        inform_name:
          get_detail.data.data.result_job_list[0].inform_name === null
            ? "-"
            : get_detail.data.data.result_job_list[0].inform_name,
        sub_type: data_sub_type.data.data.job_sub_type_dto_list,
        selected_jobtype: get_detail.data.data.result_job_list[0].job_type_id,
        selected_subtype:
          get_detail.data.data.result_job_list[0].job_sub_type_id,
        job_sub_type_id:
          get_detail.data.data.result_job_list[0].job_sub_type_id,
        sel_sla: get_detail.data.data.result_job_list[0].job_sla_id,
        sla_id: get_detail.data.data.result_job_list[0].job_sla_id,
        inform_detail: dataLocal.inform_detail,
        job_cat: GetJobCategoty.data.data.result_data,
        get_preiod: get_ma_period.data.data.ma_preiod_dto_list,
        data_translate: JSON.parse(
          data_language.data.data["masteR_LANGUAGE_DETAIL"][0].file_json
        ),
        job_progress_id:
          get_detail.data.data.result_job_list[0].job_progress_id,
        set_asset: get_cdi_new_smart_master.data.data.data,
        // selected_subtype: dataLocal.job_sub_type_name,
        data_local: dataLocal,

        Priority: parseInt(
          get_detail.data.data.result_job_list[0].priority_level
        ),
        DateTime_Install: moment(dataLocal.emp_inform_date).format(
          "DD/MM/YYYY"
        ),
        Assign_date: moment(dataLocal.last_assign_date).format("DD/MM/YYYY"),
        job_status: dataLocal.job_status,
      });

      // if (get_detail.data.data.result_job_list[0].job_sla_id != null) {
      //   this.handleproblem(
      //     "sla",
      //     get_detail.data.data.result_job_list[0].job_sla_id
      //   );
      //   this.setState({ factupdate: true });
      // } else {
      // }
    } else {
      const GetJobCategoty = await Api.post("get_job_category_V2", {
        company_id: Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        job_category_id: null,
        is_active: 1,
        date_active: 1,
      });
      const data_language = await Api.post("master_language_detail_get", {
        company_id: Cookies.get("companyid"),
        page_id: 1,
      });
      const get_cdi_new_smart = await Api.get(
        "get_cdi_new_smart",
        Cookies.get("companyid") +
        "/" +
        Cookies.get("operator_id") +
        "/" +
        dataLocal.asset_id
      );
      console.log(get_cdi_new_smart)
      const get_ma_period = await Api.post("get_ma_period", {
        pk_id: "",
        is_active: "1",
        effective: "",
        sql_where: " and company_id=" + Cookies.get("companyid"),
      });
      if (dataLocal.asset_id === "-1") {
        console.log("get_ma_period")
        this.setState({
          ckasset: true,
        });
      } else {
        this.onChangeasset(null, get_cdi_new_smart.data.data.data[0]);
      }
      const fullDetail = await Api.post("tab_list_inform_fulldetail", {
        company_id: Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        inform_job_id: dataLocal.inform_job_id,
        asset_id: dataLocal.asset_id,
        asset_no: dataLocal.asset_code,
      });
      // for (let i = 0; i < fullDetail.data.data.result_pic.length; i++) {
      //   this.state.fileList.push({
      //     uid: i,
      //     name: fullDetail.data.data.result_pic[i].pic_upload_name,
      //     status: "done",
      //     url: Api.checkPath(
      //       fullDetail.data.data.result_pic[i].pic_url_path,
      //       fullDetail.data.data.result_pic[i].pic_upload_name
      //     ),
      //   });
      // }
      this.state.form["inform_detail"] = dataLocal.inform_detail;

      this.setState({
        DateTime_Install: moment(dataLocal.inform_date).format("DD/MM/YYYY"),
        Assign_date: moment(dataLocal.inform_date).format("DD/MM/YYYY"),
        inform_detail: dataLocal.inform_detail,
        job_cat: GetJobCategoty.data.data.result_data,
        get_preiod: get_ma_period.data.data.ma_preiod_dto_list,
        data_translate: JSON.parse(
          data_language.data.data["masteR_LANGUAGE_DETAIL"][0].file_json
        ),
        set_pic: fullDetail.data.data.result_pic,
        data_local: dataLocal,
        disabled_btn: false,
        factupdate: true,
      });
    }
  }
  btnjobDetail = async (n) => {
    Api.post("get_job_type", {
      pk_id: null,
      fk_id: n,
      is_active: "1",
      effective: "1",
      sql_where: null,
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
    })
      .then((response) => {
        this.setState({
          sub_type: JSON.parse(localStorage.getItem("StatusLocal")) === 2 ? [] : this.state.sub_type,
          jobcategory: n,
          job_type: response.data.data,
        });
        if (JSON.parse(localStorage.getItem("StatusLocal")) === 1) {
          this.Setdata_jobtype(this.state.data_local.job_type_id);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  checkboxTeam = (e) => {
    this.setState({
      ckTeam: e.target.checked,
      ckSingle: false,
    });
  };
  checkboxSingle = (e) => {
    this.setState({
      ckSingle: e.target.checked,
      ckTeam: false,
    });
  };
  checkAsset = (e) => {
    this.setState({
      ckasset: e.target.checked,
      asset_name: "-",
      group_type: "-",
      asset_type: "-",
      ass_sub_type: "-",
      modal_number: "-",
      serial_number: "-",
      date_install: "-",
      warranty: "-",
      asset_ma: "-",
      location_lat: "",
      location_lon: "",
      location_name: "",
      ass_code: "",
      asset_id: "",
      area_id: "",
      sub_area_id: "",
    });
  };
  handleInputChange(event) {
    var name = event.target.name;
    var value = event.target.value;
    var form = this.state.form;
    if (name == "location_lat") {
      this.setState({
        location_lat: value,
      });
    } else if (name == "location_lon") {
      this.setState({
        location_lon: value,
      });
    } else if (name == "location_name") {
      this.setState({
        location_name: value,
      });
    }
    form[name] = value;
    this.setState(form);
  }
  handleSelectChange = async (name, value) => {
    if (name === "ma_period_id") {
      const found = this.state.get_preiod.find(
        (element) => element.ma_period_id === value
      );
      var form = this.state.form;
      form[name] = value;
      this.setState({
        period_start: moment(found.ma_time_start).format("HH:mm"),
        period_end: moment(found.ma_time_end).format("HH:mm"),
      });
      this.setState(form);
    } else {
      var form = this.state.form;
      form[name] = value;
      this.setState(form);
    }
  };
  handleDateChange(name, value) {
    if (name === "date_install") {
      var form = this.state.form;
      form[name] = moment(value).format("YYYY-MM-DD");

      this.setState({ DateTime_Install: value });
      this.setState(form);
    } else {
      var form = this.state.form;
      form[name] = moment(value).format("YYYY-MM-DD");

      this.setState({ Assign_date: value });
      this.setState(form);
    }
  }
  handleMultiChange = (data) => {
    var form = this.state.form;

    form["ma_period"] = data;
    this.setState(form);
  };
  onChangeasset = (val, obj) => {
    // console.log(val)
    // console.log(obj)

    if (obj === undefined) {
      this.setState({
        ckasset: true
      })
    }
    else {
      if (obj.asset_name === undefined) {
        this.setState({
          asset_name: obj.obj.asset_name === null ? "-" : obj.obj.asset_name,
          group_type:
            obj.obj.group_type_name === null ? "-" : obj.obj.group_type_name,
          asset_type:
            obj.obj.asset_type_name === null ? "-" : obj.obj.asset_type_name,
          ass_sub_type:
            obj.obj.asset_sub_type_name === null
              ? "-"
              : obj.obj.asset_sub_type_name,
          modal_number: obj.obj.model_no === null ? "-" : obj.obj.model_no,
          serial_number: obj.obj.serial_no === null ? "-" : obj.obj.serial_no,
          date_install:
            obj.obj.install_date === null ? "-" : obj.obj.install_date,
          warranty:
            obj.obj.warranty_expire === null ? "-" : obj.obj.warranty_expire,
          location_lat:
            obj.obj.location_lat === null ? "-" : obj.obj.location_lat,
          location_lon:
            obj.obj.location_lon === null ? "-" : obj.obj.location_lon,
          location_name:
            obj.obj.location_name === null ? "-" : obj.obj.location_name,
          ass_code: obj.obj.asset_code === null ? "-" : obj.obj.asset_code,
          area_id: obj.obj.area_id === null ? "-" : obj.obj.area_id,
          asset_id: obj.obj.asset_id === null ? "-" : obj.obj.asset_id,
          sub_area_id: obj.obj.sub_area_id === null ? "-" : obj.obj.sub_area_id,
        });
      } else {
        this.setState({
          asset_name: obj.asset_name === null ? "-" : obj.asset_name,
          group_type: obj.group_type_name === null ? "-" : obj.group_type_name,
          asset_type: obj.asset_type_name === null ? "-" : obj.asset_type_name,
          ass_sub_type:
            obj.asset_sub_type_name === null ? "-" : obj.asset_sub_type_name,
          modal_number: obj.model_no === null ? "-" : obj.model_no,
          serial_number: obj.serial_no === null ? "-" : obj.serial_no,
          date_install: obj.install_date === null ? "-" : obj.install_date,
          warranty: obj.warranty_expire === null ? "-" : obj.warranty_expire,
          location_lat: obj.location_lat === null ? "-" : obj.location_lat,
          location_lon: obj.location_lon === null ? "-" : obj.location_lon,
          location_name: obj.location_name === null ? "-" : obj.location_name,
          ass_code: obj.asset_code === null ? "-" : obj.asset_code,
          area_id: obj.area_id === null ? "-" : obj.area_id,
          asset_id: obj.asset_id === null ? "-" : obj.asset_id,
          sub_area_id: obj.sub_area_id === null ? "-" : obj.sub_area_id,
        });
      }
    }

  };
  handleSubmit = async () => {
    this.setState({
      disabled_btn: true
    })
    var convertData = this.state.DateTime_Install.split("/");
    var setDate = convertData[2] + "-" + convertData[1] + "-" + convertData[0];
    const dataset_inform = {
      inform_remark: this.state.form.remark,
      ma_period_id: this.state.form.ma_period_id,
      remark: this.state.form.remark,
      first_start_date: null,
      priority_level: this.state.Priority,
      job_no: 0,
      job_id: 0,
      job_category_id: this.state.jobcategory,
      area_id: this.state.area_id === undefined ? 0 : this.state.area_id,
      multiple_asset_flag: 0,
      location_lat:
        this.state.location_lat === "-" ? "" : this.state.location_lat,
      location_lon:
        this.state.location_lon === "-" ? "" : this.state.location_lon,
      location_name: this.state.location_name,
      asset_id: this.state.asset_id,
      asset_code: this.state.ass_code,
      sub_area_id: this.state.sub_area_id,
      job_status: 0,
      create_by: Cookies.get("username"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      job_type_id: this.state.selected_jobtype,
      job_sub_type_id: this.state.selected_subtype,
      inform_name: Cookies.get("username"),
      inform_detail: this.state.form.inform_detail,
      ...this.state.WorkFlow[0],
      service_type_level_id: this.state.service_type_level_id,
      job_sla_id: this.state.sla_id,
      job_sla_id: this.state.sla_id,
      plan_start_date: moment(this.state.plan_date[0]).format("YYYY-MM-DD HH:mm:ss"),
      plan_end_date: moment(this.state.plan_date[1]).format("YYYY-MM-DD HH:mm:ss"),
    };
    const dataset_edit = {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      job_id: this.state.data_local.job_id,
      job_category_id: this.state.jobcategory,
      job_no: this.state.data_local.job_no,
      job_type_id: this.state.data_local.job_type_id,
      job_sub_type_id: this.state.job_sub_type_id,
      multiple_asset_flag: "0",
      asset_id: this.state.asset_id,
      asset_code: this.state.ass_code,
      area_id: this.state.area_id === undefined ? 0 : this.state.area_id,
      sub_area_id: this.state.sub_area_id,
      location_lat:
        this.state.location_lat === "-" ? "" : this.state.location_lat,
      location_lon:
        this.state.location_lon === "-" ? "" : this.state.location_lon,
      location_name: this.state.location_name,
      emp_inform_id: "",
      emp_inform_date: "",
      inform_detail: this.state.form.inform_detail,
      inform_remark: this.state.form.remark,
      priority_level: this.state.Priority,
      is_active: "1",
      job_status: this.state.job_status,
      last_job_progress_id: "",
      last_assign_date: "",
      last_assign_type: "",
      last_person_id: "",
      last_job_remark: "",
      create_method: "",
      update_by: Cookies.get("userId"),
      create_by: Cookies.get("userId"),
      sla_level_id: 0,
      trans_flag: "",
      total_assign: "",
      problem_detail: "",
      result_detail: "",
      total_amount: 0,
      total_vat: 0,
      total_amount_bf_vat: "",
      first_start_date: null,
      finish_date: "",
      approved_status: "",
      approved_by: "",
      approved_remark: "",
      use_material: "",
      total_days: 0,
      total_hour: 0,
      total_min: 0,
      sla_pass: "",
      picture_location: "",
      picture_path: "",
      ma_period_id: this.state.form.ma_period_id,
      service_type_level_id: this.state.service_type_level_id,
      job_sla_id: this.state.sla_id,
      job_point: "",
      form_id: "",
      data_dynamic: "",
      inform_name: this.state.inform_name,
      interface_id: "",
      interface_sub_id: "",
      interface_type: "",
      interface_attrib1: "",
      interface_attrib2: "",
      interface_attrib3: "",
      plan_start_date: moment(this.state.plan_date[0]).format("YYYY-MM-DD HH:mm:ss"),
      plan_end_date: moment(this.state.plan_date[1]).format("YYYY-MM-DD HH:mm:ss"),
      // job_fack_checksla_id: this.state.sla_id,
    };


    Api.post(
      JSON.parse(localStorage.getItem("StatusLocal")) === 1
        ? "V2/update_oper_job"
        : "V2/insert_oper_job_multi_asset",
      JSON.parse(localStorage.getItem("StatusLocal")) === 1
        ? dataset_edit
        : [dataset_inform]
    )
      .then(async (response) => {
        if (response.data.result.code === "P") {
          const { fileList } = this.state;
          const formData = new FormData();
          fileList.forEach((file) => {
            formData.append("files", file["originFileObj"]);
            formData.append("job_id", JSON.parse(localStorage.getItem("StatusLocal")) === 1 ? this.state.data_local.job_id : response.data.data.result_data[0].job_id);
            formData.append("job_progress_id", JSON.parse(localStorage.getItem("StatusLocal")) === 1 ? this.state.job_progress_id : 1);
            formData.append("company_id", Cookies.get("companyid"));
            formData.append("operator_id", Cookies.get("operator_id"));
            formData.append("project_id", Cookies.get("project_id"));
            formData.append("job_category_id", this.state.jobcategory);
            formData.append("job_type_id", this.state.selected_jobtype);
            formData.append("asset_id", this.state.asset_id);
            formData.append("create_by", Cookies.get("username"));
          });
          if (JSON.parse(localStorage.getItem("StatusLocal")) === 2) {
            const tab_update_inform_approve = await Api.post(
              "tab_update_inform_approve",
              {
                company_id: Cookies.get("companyid"),
                operator_id: Cookies.get("operator_id"),
                project_id: Cookies.get("project_id"),
                inform_job_id: JSON.parse(localStorage.getItem("informDetail"))
                  .inform_job_id,
                flag_approve: 1,
                create_by: Cookies.get("userId"),
              }
            );
            const tab_update_inform_is_create = await Api.post(
              "tab_update_inform_is_create",
              {
                company_id: Cookies.get("companyid"),
                operator_id: Cookies.get("operator_id"),
                project_id: Cookies.get("project_id"),
                inform_job_id: JSON.parse(localStorage.getItem("informDetail"))
                  .inform_job_id,
                job_id: response.data.data.result_data[0]["job_id"],
                create_by: Cookies.get("username"),
              }
            );
          }
          if (fileList.length > 0) {
            await axios({
              method: "post",
              url: this.state.urlpath + "InsertOperJobFile/",
              data: formData,
              headers: {
                TokenUser: Cookies.get(`OperationToken`),
              },
              processData: false,
            })
              .then(function (response) {
                for (let i = 0; i < formData.getAll("files").length; i++) {
                  formData.delete("files");
                  formData.delete("job_id");
                  formData.delete("job_progress_id");
                  formData.delete("company_id");
                  formData.delete("operator_id");
                  formData.delete("project_id");
                  formData.delete("job_category_id");
                  formData.delete("job_type_id");
                  formData.delete("asset_id");
                  formData.delete("create_by");
                  message.success("upload successfully.");
                }
                this.setState({
                  fileList: [],
                  uploading: false,
                  modalstatus: true,
                });
              })
              .catch(function (response) {
                console.log(response);
              });
            this.setState({
              fileList: [],
              uploading: false,
              modalstatus: true,
            });
          } else {
            this.setState({
              fileList: [],
              modalstatus: true,
            });
          }
        }
      })
      .catch((e) => {
        this.setState({
          disabled_btn: false
        })
        console.log(e);
      });
  };
  setConditions(data) {
    let option = data.split(",");
    let options = [];
    for (let i = 0; i < option.length; i++) {
      let _option = option[i].split("=");
      options.push({
        column_name: _option[0],
        value: _option[1],
      });
    }
    return options;
  }
  async Setdata_jobtype(value) {
    const checkwf = this.state.job_type.find(
      (element) => parseInt(element.job_type_id) === parseInt(value)
    );
    if (checkwf === null || checkwf === undefined) {
      this.setState({
        checkbtn: false,
      });
    } else {
      Api.post("getButtonDetailWeb", {
        WF_ID: checkwf.wf_id,
        CompanyID: Cookies.get("companyid"),
        ProjectID: Cookies.get("project_id"),
        JobTypeID: value,
        Version: 1,
        MainProcessID: "0",
        SubProcessID: "-1",
        ActionID: 1,
        UserName: Cookies.get("username"),
        operator_id: Cookies.get("operator_id"),
      })
        .then((response) => {
          if (response.data.return_nextWorkFlow.length === 0) {
            this.setState({
              checkbtn: false,
              status_button_workflow: "กรุณาตรวจสอบการเลือก Job Type !!",
            });
          } else {
            this.setState({
              checkbtn: true,
              selected_jobtype:
                JSON.parse(localStorage.getItem("StatusLocal")) === 1
                  ? this.state.selected_jobtype
                  : value,
              WorkFlow: response.data.return_nextWorkFlow,
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
    if (JSON.parse(localStorage.getItem("StatusLocal")) === 2) {
      Api.post("get_job_sub_type", {
        job_sub_type_id: null,
        job_category_id: this.state.jobcategory,
        job_type_id: value,
        is_active: 1,
        effective: 1,
        sql_where: " and company_id=" + Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
      })
        .then((response) => {
          this.setState({
            selected_jobtype: value || null,
            selected_subtype: response.data.data.job_sub_type_dto_list[0].job_sub_type_id,
            sub_type: response.data.data.job_sub_type_dto_list,
          });
        })
        .catch((e) => {
          console.log(e);
        });
    }
    Api.post("get_service_type_ma_list_each_level", {
      company_id: Cookies.get("companyid"),
      job_category_id: this.state.jobcategory,
      job_type_id: value,
      service_lv1: null,
      service_lv2: null,
      service_lv3: null,
      service_lv4: null,
      operator_id: Cookies.get("operator_id"),
    })
      .then((response) => {
        const result = response.data.data.result.filter(
          (data) =>
            data.service_desc.toLowerCase() ===
            this.state.asset_type.toLowerCase()
        );
        if (result.length === 0) {
          this.setState({
            ObjectPart: response.data.data.result,
            checkAssetType: true,
          });
        } else {
          this.setState({
            ObjectPart: response.data.data.result,
            customs: { select_object_path: result[0].service_type_level_id },
          });
          Api.post("get_service_type_ma_list_each_level", {
            company_id: Cookies.get("companyid"),
            job_category_id: this.state.jobcategory,
            job_type_id: value,
            service_lv1: result[0].service_type_level_id.substring(0, 2),
            service_lv2: null,
            service_lv3: null,
            service_lv4: null,
            operator_id: Cookies.get("operator_id"),
          })
            .then((response_service) => {
              const result_service = response_service.data.data.result.filter(
                (data) => data.service_desc === checkwf.job_type_name
              );

              if (result_service.length === 0) {
                this.setState({
                  serviceType: response_service.data.data.result,
                  sel_type: response_service.data.data.result[0].service_type_level_id,
                  checkAssetType: true,
                })
              }
              else {

                this.setState({
                  serviceType: response_service.data.data.result,
                  service_type_level_id: result_service[0].service_type_level_id,
                  sel_type: result_service[0].service_type_level_id,
                  sel_new_type: null,
                  sel_sub_cat: null,
                  newType: [],
                  subCategory: [],
                  std_hour: "",
                  std_day: "",
                  std_minute: "",
                  sla_id: "",
                  sel_sla: null,
                  checkAssetType: false,
                });
                Api.post("get_job_sla_special", {
                  company_id: Cookies.get("companyid"),
                  operator_id: Cookies.get("operator_id"),
                  project_id: Cookies.get("project_id"),
                  job_category_id: this.state.jobcategory,
                  job_type_id: value,
                  job_sub_type_id: 0,
                  service_type_level_id: null,
                  v_where:
                    " and service_type_level_id like concat('" +
                    result_service[0].service_type_level_id.substring(0, 4) +
                    "','%')",
                })
                  .then((result_sub_category) => {
                    this.setState({
                      subCategory: result_sub_category.data.data.result,
                      service_type_level_id: result_sub_category.data.data.result[0].service_type_level_id,
                    });
                  })
                  .catch((e) => {
                    console.log(e);
                  });

              }
            })
            .catch((e) => {
              console.log(e);
            });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  handleproblem = async (name, value) => {
    if (JSON.parse(localStorage.getItem("StatusLocal")) === 2) {
      switch (name) {
        case "objectpart":
          this.setState({
            customs: {
              select_object_path: value,
            },
          });
          Api.post("get_service_type_ma_list_each_level", {
            company_id: Cookies.get("companyid"),
            job_category_id: this.state.jobcategory,
            job_type_id: this.state.selected_jobtype,
            service_lv1: value.substring(0, 2),
            service_lv2: null,
            service_lv3: null,
            service_lv4: null,
            operator_id: Cookies.get("operator_id"),
          })
            .then((response) => {
              this.setState({
                service_type_level_id: value,
                serviceType: response.data.data.result,
                service_type_level_id: value,
                sel_type: null,
                sel_new_type: null,
                sel_sub_cat: null,
                newType: [],
                subCategory: [],
                // sla_level: [],
                std_hour: "",
                std_day: "",
                std_minute: "",
                sla_id: "",
                sel_sla: null,
              });
            })
            .catch((e) => {
              console.log(e);
            });
          break;
        case "servicetype":
          Api.post("get_service_type_ma_list_each_level", {
            company_id: Cookies.get("companyid"),
            job_category_id: this.state.jobcategory,
            job_type_id: this.state.selected_jobtype,
            service_lv1: value.substring(0, 2),
            service_lv2: value.substring(2, 4),
            service_lv3: null,
            service_lv4: null,
            operator_id: Cookies.get("operator_id"),
          })
            .then((response) => {
              this.setState({
                service_type_level_id: value,
                sel_type: value,
                service_type_level_id: value,
                newType: response.data.data.result,
                sel_new_type: null,
                sel_sub_cat: null,
                subCategory: [],
                // sla_level: [],
                std_hour: "",
                std_day: "",
                std_minute: "",
                sla_id: "",
                sel_sla: null,
              });
            })
            .catch((e) => {
              console.log(e);
            });
          break;
        case "new_type":
          Api.post("get_service_type_ma_list_each_level", {
            company_id: Cookies.get("companyid"),
            job_category_id: this.state.jobcategory,
            job_type_id: this.state.selected_jobtype,
            service_lv1: value.substring(0, 2),
            service_lv2: value.substring(2, 4),
            service_lv3: value.substring(4, 6),
            service_lv4: null,
            operator_id: Cookies.get("operator_id"),
          })
            .then((response) => {
              this.setState({
                service_type_level_id: value,
                sel_new_type: value,
                service_type_level_id: value,
                subCategory: response.data.data.result,
                sel_sub_cat: null,
                // sla_level: [],
                std_hour: "",
                std_day: "",
                std_minute: "",
                sla_id: "",
                sel_sla: null,
              });
            })
            .catch((e) => {
              console.log(e);
            });
          break;
        case "sub_category":
          if (this.state.checkAssetType === true) {
            const get_job_sla = await Api.post("get_job_sla", {
              company_id: Cookies.get("companyid"),
              operator_id: Cookies.get("operator_id"),
              project_id: Cookies.get("project_id"),
              job_category_id: this.state.jobcategory,
              job_type_id: this.state.selected_jobtype,
              job_sub_type_id: 0,
              service_type_level_id:
                JSON.parse(localStorage.getItem("StatusLocal")) === 2
                  ? value
                  : this.state.service_type_level_id,
            });
            this.setState({
              disabled_btn: false,
              service_type_level_id: value,
              sla_level: get_job_sla.data.data.result,
              sel_sub_cat: value,

              sel_sla: get_job_sla.data.data.result[0].job_sla_id,
              std_hour: get_job_sla.data.data.result[0].sla_time_hour,
              std_day: get_job_sla.data.data.result[0].sla_time_day,
              std_minute: get_job_sla.data.data.result[0].sla_time_min,
              sla_id: get_job_sla.data.data.result[0].job_sla_id,
            });
          } else {
            const filter_subcat = this.state.subCategory.filter(
              (data) => data.service_type_level_id === value
            );
            this.setState({
              disabled_btn: false,
              service_type_level_id: value,
              sel_new_type: value,
              newType: filter_subcat,
              sel_sub_cat: value,

              sla_level: filter_subcat,
              sel_sla: filter_subcat[0].job_sla_id,
              std_hour: filter_subcat[0].sla_time_hour,
              std_day: filter_subcat[0].sla_time_day,
              std_minute: filter_subcat[0].sla_time_min,
              sla_id: value,
            });
          }
          break;
        case "sla":
          this.setState({
            std_hour: "",
            std_day: "",
            std_minute: "",
            sla_id: "",
          });
          const sla_data = this.state.sla_level.find(
            (element) => element.job_sla_id === value
          );
          this.setState({
            disabled_btn: false,
            sel_sla: value,
            std_hour: sla_data.sla_time_hour,
            std_day: sla_data.sla_time_day,
            std_minute: sla_data.sla_time_day,
            sla_id: value,
          });
          break;
        default:
          return null;
      }
    } else {
      switch (name) {
        case "objectpart":
          this.setState({
            customs: {
              select_object_path: value,
            },
          });
          Api.post("get_service_type_ma_list_each_level", {
            company_id: Cookies.get("companyid"),
            job_category_id: this.state.jobcategory,
            job_type_id: this.state.selected_jobtype,
            service_lv1: value.substring(0, 2),
            service_lv2: null,
            service_lv3: null,
            service_lv4: null,
            operator_id: Cookies.get("operator_id"),
          })
            .then((response) => {
              this.setState({
                service_type_level_id: value,
                serviceType: response.data.data.result,
                sel_type: null,
                sel_new_type: null,
                sel_sub_cat: null,
                newType: [],
                subCategory: [],
                // sla_level: [],
                std_hour: "",
                std_day: "",
                std_minute: "",
                sla_id: "",
                sel_sla: null,
              });
            })
            .catch((e) => {
              console.log(e);
            });
          break;
        case "servicetype":
          Api.post("get_service_type_ma_list_each_level", {
            company_id: Cookies.get("companyid"),
            job_category_id: this.state.jobcategory,
            job_type_id: this.state.selected_jobtype,
            service_lv1: value.substring(0, 2),
            service_lv2: value.substring(2, 4),
            service_lv3: null,
            service_lv4: null,
            operator_id: Cookies.get("operator_id"),
          })
            .then((response) => {
              this.setState({
                newType: response.data.data.result,
                service_type_level_id: value,
                sel_type: value,
                sel_new_type: null,
                sel_sub_cat: null,
                subCategory: [],
                std_hour: "",
                std_day: "",
                std_minute: "",
                sla_id: "",
                sel_sla: null,
              });
            })
            .catch((e) => {
              console.log(e);
            });
          break;
        case "new_type":
          Api.post("get_service_type_ma_list_each_level", {
            company_id: Cookies.get("companyid"),
            job_category_id: this.state.jobcategory,
            job_type_id: this.state.selected_jobtype,
            service_lv1: value.substring(0, 2),
            service_lv2: value.substring(2, 4),
            service_lv3: value.substring(4, 6),
            service_lv4: null,
            operator_id: Cookies.get("operator_id"),
          })
            .then((response) => {
              this.setState({
                subCategory: response.data.data.result,
                service_type_level_id: value,
                sel_new_type: value,
                sel_sub_cat: null,
                std_hour: "",
                std_day: "",
                std_minute: "",
                sla_id: "",
                sel_sla: null,
              });
            })
            .catch((e) => {
              console.log(e);
            });
          break;
        case "sub_category":
          const get_job_sla = await Api.post("get_job_sla", {
            company_id: Cookies.get("companyid"),
            operator_id: Cookies.get("operator_id"),
            project_id: Cookies.get("project_id"),
            job_category_id: this.state.jobcategory,
            job_type_id: this.state.selected_jobtype,
            job_sub_type_id: 0,
            service_type_level_id: value,
          });
          this.setState({
            disabled_btn: false,
            sla_level: get_job_sla.data.data.result,
            sel_sub_cat: value,
            service_type_level_id: get_job_sla.data.data.result[0].service_type_level_id,
            sel_sla: get_job_sla.data.data.result[0].job_sla_id,
            std_hour: get_job_sla.data.data.result[0].sla_time_hour,
            std_day: get_job_sla.data.data.result[0].sla_time_day,
            std_minute: get_job_sla.data.data.result[0].sla_time_min,
            sla_id: get_job_sla.data.data.result[0].job_sla_id,
          });
          break;
        case "sla":
          this.setState({
            sel_sla: value,
          });
          this.setState({
            std_hour: "",
            std_day: "",
            std_minute: "",
            sla_id: "",
          });
          var sla_data = this.state.sla_level.find(
            (element) => element.job_sla_id === value
          );
          this.setState({
            disabled_btn: false,
            sel_sla: value,
            service_type_level_id: sla_data.service_type_level_id,
            std_hour: sla_data["sla_time_hour"] === null ? 0 : sla_data["sla_time_hour"],
            std_day: sla_data.sla_time_day === null ? 0 : sla_data.sla_time_day,
            std_minute: sla_data.sla_time_day === null ? 0 : sla_data.sla_time_min,
            sla_id: value,
          });

          break;
        default:
          return null;
      }
    }
  };
  getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }
  handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await this.getBase64(file.originFileObj);
    }
  };
  handleChange = ({ fileList }) => this.setState({ fileList });
  handleCancel = () => this.setState({ previewVisible: false });
  onChangePriority = (e) => {
    this.setState({
      Priority: e.target.value,
    });
  };
  defaultSLA = async (job_type_id, lv1, lv2, lv3, lv4, sla_id) => {

    const defaultValue_LV1 = await Api.post(
      "get_service_type_ma_list_each_level",
      {
        company_id: Cookies.get("companyid"),
        job_category_id: this.state.jobcategory,
        job_type_id: job_type_id,
        service_lv1: null,
        service_lv2: null,
        service_lv3: null,
        service_lv4: null,
        operator_id: Cookies.get("operator_id"),
      }
    );
    const defaultValue_LV2 = await Api.post(
      "get_service_type_ma_list_each_level",
      {
        company_id: Cookies.get("companyid"),
        job_category_id: this.state.jobcategory,
        job_type_id: job_type_id,
        service_lv1: lv1,
        service_lv2: null,
        service_lv3: null,
        service_lv4: null,
        operator_id: Cookies.get("operator_id"),
      }
    );
    const defaultValue_LV3 = await Api.post(
      "get_service_type_ma_list_each_level",
      {
        company_id: Cookies.get("companyid"),
        job_category_id: this.state.jobcategory,
        job_type_id: job_type_id,
        service_lv1: lv1,
        service_lv2: lv2,
        service_lv3: null,
        service_lv4: null,
        operator_id: Cookies.get("operator_id"),
      }
    );
    const defaultValue_LV4 = await Api.post(
      "get_service_type_ma_list_each_level",
      {
        company_id: Cookies.get("companyid"),
        job_category_id: this.state.jobcategory,
        job_type_id: job_type_id,
        service_lv1: lv1,
        service_lv2: lv2,
        service_lv3: lv3,
        service_lv4: lv4,
        operator_id: Cookies.get("operator_id"),
      }
    );
    const defaultValue_Sla = await Api.post("get_job_sla", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      job_category_id: this.state.jobcategory,
      job_type_id: this.state.selected_jobtype,
      job_sub_type_id: 0,
      service_type_level_id: sla_id,
    });
    const filter_lv1 = defaultValue_LV1.data.data.result?.filter(data =>
      data.service_type_level_id.substring(0, 2) === lv1
    );
    const filter_lv2 = defaultValue_LV2.data.data.result?.filter(data => data.service_type_level_id.substring(0, 4) === lv1 + lv2);
    const filter_lv3 = defaultValue_LV3.data.data.result?.filter(data =>
      data.service_type_level_id.substring(0, 6) === lv1 + lv2 + lv3);
    const filter_lv4 = defaultValue_LV4.data.data.result.filter(data => data.service_type_level_id === sla_id);
    this.setState({

      ObjectPart: defaultValue_LV1.data.data.result,
      customs: { select_object_path: filter_lv1.length > 0 ? filter_lv1[0].service_type_level_id : [] },
      checkAssetType: true,
      serviceType: defaultValue_LV2.data.data.result,
      sel_type: filter_lv2.length > 0 ? filter_lv2[0].service_type_level_id : [],
      newType: defaultValue_LV3.data.data.result,
      sel_new_type: filter_lv3.length > 0 ? filter_lv3[0].service_type_level_id : [],
      subCategory: defaultValue_LV4.data.data.result,
      sel_sub_cat: filter_lv4.length > 0 ? filter_lv4[0].service_type_level_id : [],

      sla_level: defaultValue_Sla.data.data.result,
      sel_sla: defaultValue_Sla.data.data.result.length > 0 ? defaultValue_Sla.data.data.result[0]["job_sla_id"] : null,
      std_hour: defaultValue_Sla.data.data.result.length > 0 ? defaultValue_Sla.data.data.result[0]["sla_time_hour"] : 0,
      std_day: defaultValue_Sla.data.data.result.length > 0 ? defaultValue_Sla.data.data.result[0]["sla_time_day"] : 0,
      std_minute: defaultValue_Sla.data.data.result.length > 0 ? defaultValue_Sla.data.data.result[0]["sla_time_min"] : 0,
      service_type_level_id: sla_id,
      disabled_btn: false,
      factupdate: true
    })

  }
  render() {
    const {
      loading,
      title,
      statusbtn,
      job_type,
      sub_type,
      startDate,
      options,
      uploading,
      fileList,
      jobcategory,
      jobtype,
      ckSingle,
      ckTeam,
      form,
      ckasset,
      ckcm,
      ckpm,
    } = this.state;
    const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY"];
    const props = {
      onRemove: (file) => {
        this.setState((state) => {
          const index = state.fileList.indexOf(file);
          const newFileList = state.fileList.slice();
          newFileList.splice(index, 1);
          return {
            fileList: newFileList,
          };
        });
      },
      beforeUpload: (file) => {
        this.setState((state) => ({
          fileList: [...state.fileList, file],
        }));
        return false;
      },
      fileList,
    };
    const uploadButton = (
      <div>
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    );
    const job_cat_btn = this.state.job_cat.map((job_cat, index) => {
      let thismr = "";
      if ((index + 1) % 5 == 0 && index != 0) {
        thismr = "mr-2 ";
      }
      return (
        <div
          className={"col-2 " + thismr + "p0"}
          style={{ marginBottom: "10px" }}
          key={index}
        >
          <button
            type="button"
            className={
              this.state.jobcategory == job_cat.job_category_id
                ? "btndetailshow"
                : "btndetailhide"
            }
            disabled={this.state.fack_check === 1 ? true : false}
            // disabled={true}
            onClick={this.btnjobDetail.bind(this, job_cat.job_category_id)}
          >
            <img
              style={{
                float: "right",
                marginRight: "10px",
              }}
              src={Api.absoluteUrl(
                this.state.jobcategory == job_cat.job_category_id
                  ? "/icon/job_show.svg"
                  : "/icon/job_dis.svg"
              )}
            />
            <br className="mt-2" />
            <img
              style={{
                float: "center",
                marginLeft: "-15px",
              }}
              src={Api.absoluteUrl("/icon/" + job_cat.icon_name)}
            />
            <span
              style={{
                marginLeft: "-20px",
                fontSize: "14px",
                color: "#0500A3",
              }}
            >
              <br className="mt-2" />
              {job_cat.job_category_name}
            </span>
          </button>
        </div>
      );
    });
    return (
      <LayoutOperation title={title}>
        {this.state.modalstatus ? (
          <ModalSuccess
            status="Successfully"
            path_location={Api.absoluteUrl("/ma_list")}
          />
        ) : null}
        {/* {console.log(this.state.ckasset)} */}
        {this.state.factupdate === true ? (
          <>
            <div className="row">
              <div className="col-sm-6 ml-5" style={{ marginTop: "4%" }}>
                {/* <Link
                  className="font-thai-r font20 c-white"
                  to="/ma_list"

                >
                  <i className="fas fa-chevron-left" style={{ color: "#2b2d33", fontSize: "14px" }}></i>
                  <span style={{ marginLeft: "8px", marginBottom: "20px", color: "#2b2d33" }}>
                    Back
                    </span>
                </Link> */}
              </div>
              {/* <div className="col-sm-6">
                <ol
                  className="breadcrumb float-sm-right mr-5  mt-3"
                  style={{ background: "inherit" }}
                >
                  <li className="breadcrumb-item">MA List</li>
                  <li className="breadcrumb-item">
                    <a href="#"> {this.state.title}</a>
                  </li>
                </ol>
              </div> */}
            </div>
            <div
              className="container mb-2"
              style={{ maxWidth: "95%", marginTop: "0%" }}
            >
              <div className="row">
                <div
                  className="col-12 mt-2 "
                  style={{ paddingLeft: "0px", paddingRight: "0px" }}
                >
                  <span style={{ color: "#0500A3", fontSize: "16px" }}>
                    <img
                      src={Api.absoluteUrl("/icon/pust.svg")}
                      width="14"
                      className="mr-2"
                    />
                    <b> {this.state.title} </b>
                  </span>
                  <div className="card mt-2" style={{ width: "95%" }}>
                    <div className="card-body">
                      <div
                        className={
                          this.state.statusbtn == "2"
                            ? "mt-2 divshow"
                            : "mt-2  divhide"
                        }
                      >
                        <div className="row">
                          <div className="col-2"> </div>
                          <div className="col-10">
                            <img
                              style={{
                                float: "left",
                                marginTop: "7px",
                                marginRight: "10px",
                              }}
                              src={Api.absoluteUrl("/icon/setting.svg")}
                            />
                            <span className="jobdetail">
                              {
                                this.state.data_translate[
                                Cookies.get("locale")
                                ]["job_detail"]
                              }
                            </span>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-3"> </div>
                          <div className="col-9">
                            <div className="row">
                              <div className="col-12">
                                <label className="labeaddjob">
                                  {
                                    this.state.data_translate[
                                    Cookies.get("locale")
                                    ]["job_category"]
                                  }
                                  <b style={{ color: "#DF4547" }}>*</b>
                                </label>
                                <br /> <div className="row">{job_cat_btn}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-5">
                          <div className="col-3"> </div>
                          <div className="col-9">
                            <div className="row">
                              <div className="col-5">
                                <label className="labeaddjob">
                                  {
                                    this.state.data_translate[
                                    Cookies.get("locale")
                                    ]["job_type"]
                                  }
                                  <b style={{ color: "#DF4547" }}> * </b>
                                </label>
                                <br />
                                <select
                                  style={{ height: "30px" }}
                                  className="dropdrowtype"
                                  disabled={
                                    this.state.fack_check === 1 ? true : false
                                  }
                                  onChange={(e) =>
                                    this.Setdata_jobtype(e.target.value)
                                  }
                                  defaultValue={
                                    this.state.selected_jobtype || ""
                                  }
                                  value={this.state.selected_jobtype}
                                >
                                  <option value="">
                                    Please select
                                  </option>
                                  {this.state.job_type.map((item, index) => (
                                    <option
                                      value={item.job_type_id}
                                      defaultValue={this.state.selected_jobtype}
                                      key={index + 1}
                                    >
                                      {item.job_type_name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className="col-6 ml-4">
                                <label className="labeaddjob">
                                  {
                                    this.state.data_translate[
                                    Cookies.get("locale")
                                    ]["job_sub_type"]
                                  }
                                  {/* <b style={{ color: "#DF4547" }}> * </b> */}
                                </label>
                                <br />
                                <select
                                  style={{ height: "30px" }}
                                  className="dropdrowtype"
                                  disabled={
                                    this.state.fack_check === 1 ? true : false
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      selected_subtype: e.target.value || null,
                                    })
                                  }
                                  value={
                                    localStorage.getItem("StatusLocal") === 1
                                      ? this.state.selected_subtype
                                      : this.state.selected_subtype ===
                                        undefined ||
                                        this.state.selected_subtype === null
                                        ? ""
                                        : this.state.selected_subtype
                                  }
                                >
                                  <option value="" disabled>
                                    Please select
                                  </option>
                                  {this.state.sub_type.map((item, index) => (
                                    <option value={item.job_sub_type_id}>
                                      {item.job_type_name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={
                    this.state.statusbtn == "2"
                      ? "card mt-2 divshow"
                      : "card mt-2 divhide"
                  }
                  style={{ width: "95%" }}
                >
                  <div className="card-body">
                    <div
                      className={
                        this.state.statusbtn == "2"
                          ? "mt-2 divshow"
                          : "mt-2  divhide"
                      }
                    >
                      <div className="row mt-3">
                        <div className="col-2"> </div>
                        <div className="col-10">
                          <img
                            style={{
                              float: "left",
                              marginTop: "7px",
                              marginRight: "10px",
                            }}
                            src={Api.absoluteUrl("/icon/Asset.svg")}
                          />
                          <span className="jobdetail">
                            {
                              this.state.data_translate[Cookies.get("locale")][
                              "asset_detail"
                              ]
                            }
                          </span>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-3"> </div>
                        <div className="col-9">
                          <div className="row">
                            <div className="col-4" style={{ margin: "auto" }}>
                              <Checkbox
                                onChange={this.checkAsset}
                                checked={this.state.ckasset}
                                style={{ fontSize: "20px", color: "#0500A3" }}
                              >
                                <label className="labelheader">
                                  {
                                    this.state.data_translate[
                                    Cookies.get("locale")
                                    ]["no_asset"]
                                  }
                                </label>
                              </Checkbox>
                              <br />
                              <div
                                className={
                                  this.state.ckasset == true
                                    ? "divhide"
                                    : "divshow"
                                }
                              >
                                <label className="labeaddjob mt-4">
                                  Asset Code
                                  <b style={{ color: "#DF4547" }}> * </b>
                                </label>
                                <br />
                                {this.state.status_cookie === 1 ? (
                                  <input
                                    type="text"
                                    className="inputfile"
                                    style={{ width: "100%" }}
                                    name="location_name"
                                    disabled={
                                      this.state.ckasset === true
                                        ? ""
                                        : "disabled"
                                    }
                                    value={this.state.asset_code}
                                  ></input>
                                ) : (
                                  <Select
                                    // showSearch
                                    style={{
                                      border: "0px",
                                      color: "#000f9f !important",
                                    }}
                                    placeholder="Select a Asset Code"
                                    className="inputfile"
                                    onChange={this.onChangeasset}
                                    defaultValue={
                                      this.state.factupdate === true
                                        ? this.state.ass_code
                                        : null
                                    }
                                    disabled={
                                      JSON.parse(
                                        localStorage.getItem("StatusLocal")
                                      ) === 1
                                        ? false
                                        : true
                                    }
                                  >
                                    {this.state.set_asset.map((item, index) => (
                                      <Select.Option
                                        value={item.asset_code}
                                        key={index}
                                        obj={item}
                                      >
                                        {item.asset_code}
                                      </Select.Option>
                                    ))}
                                  </Select>
                                )}
                              </div>
                            </div>
                            <div
                              className={
                                this.state.ckasset == true
                                  ? "col-6 divhide"
                                  : "col-6 divshow"
                              }
                              style={{ margin: "auto" }}
                            >
                              <div className="row">
                                <div className="col-4">
                                  <label className="labelheader">
                                    {
                                      this.state.data_translate[
                                      Cookies.get("locale")
                                      ]["asset_name"]
                                    }
                                  </label>
                                </div>
                                <div className="col-6">
                                  <label className="labelddetail">
                                    {this.state.asset_name}
                                  </label>
                                </div>

                                <div className="col-4">
                                  <label className="labelheader">
                                    {
                                      this.state.data_translate[
                                      Cookies.get("locale")
                                      ]["group_type"]
                                    }
                                  </label>
                                </div>
                                <div className="col-6">
                                  <label className="labelddetail">
                                    {this.state.group_type}
                                  </label>
                                </div>
                                <div className="col-4">
                                  <label className="labelheader">
                                    {
                                      this.state.data_translate[
                                      Cookies.get("locale")
                                      ]["asset_type"]
                                    }
                                  </label>
                                </div>
                                <div className="col-6">
                                  <label className="labelddetail">
                                    {this.state.asset_type}
                                  </label>
                                </div>

                                <div className="col-4">
                                  <label className="labelheader">
                                    {
                                      this.state.data_translate[
                                      Cookies.get("locale")
                                      ]["asset_sub_type"]
                                    }
                                  </label>
                                </div>
                                <div className="col-6">
                                  <label className="labelddetail">
                                    {this.state.ass_sub_type}
                                  </label>
                                </div>

                                <div className="col-4">
                                  <label className="labelheader">
                                    {
                                      this.state.data_translate[
                                      Cookies.get("locale")
                                      ]["model_number"]
                                    }
                                  </label>
                                </div>
                                <div className="col-6">
                                  <label className="labelddetail">
                                    {this.state.modal_number}
                                  </label>
                                </div>
                                <div className="col-4">
                                  <label className="labelheader">
                                    {
                                      this.state.data_translate[
                                      Cookies.get("locale")
                                      ]["serial_number"]
                                    }
                                  </label>
                                </div>
                                <div className="col-6">
                                  <label className="labelddetail">
                                    {this.state.serial_number}
                                  </label>
                                </div>

                                <div className="col-4">
                                  <label className="labelheader">
                                    {
                                      this.state.data_translate[
                                      Cookies.get("locale")
                                      ]["date_install"]
                                    }
                                  </label>
                                </div>
                                <div className="col-6">
                                  <label className="labelddetail">
                                    {this.state.date_install === "-" ||
                                      this.state.date_install === null
                                      ? "-"
                                      : moment(this.state.date_install).format(
                                        "DD/MM/YYYY HH:mm"
                                      )}
                                  </label>
                                </div>

                                <div className="col-4">
                                  <label className="labelheader">
                                    {
                                      this.state.data_translate[
                                      Cookies.get("locale")
                                      ]["warranty"]
                                    }
                                  </label>
                                </div>
                                <div className="col-6">
                                  <label className="labelddetail">
                                    {this.state.warranty === "-" ||
                                      this.state.warranty === null
                                      ? "-"
                                      : moment(this.state.warranty).format(
                                        "DD/MM/YYYY HH:mm"
                                      )}
                                  </label>
                                </div>
                                <div className="col-4">
                                  <label className="labelheader">
                                    {
                                      this.state.data_translate[
                                      Cookies.get("locale")
                                      ]["ma_period"]
                                    }
                                  </label>
                                </div>
                                <div className="col-6">
                                  <label className="labelddetail">
                                    {this.state.asset_ma}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={
                    this.state.statusbtn == "2"
                      ? "card mt-2 divshow"
                      : "card mt-2 divhide"
                  }
                  style={{ width: "95%" }}
                >
                  <div className="card-body">
                    <div
                      className={
                        this.state.statusbtn == "2"
                          ? "mt-2 divshow"
                          : "mt-2  divhide"
                      }
                    >
                      <div className="row mt-3">
                        <div className="col-2"> </div>

                        <div className="col-10">
                          <img
                            style={{
                              float: "left",
                              marginTop: "7px",
                              marginRight: "10px",
                            }}
                            src={Api.absoluteUrl("/icon/location.svg")}
                          />
                          <span className="jobdetail">
                            {
                              this.state.data_translate[Cookies.get("locale")][
                              "location"
                              ]
                            }
                          </span>
                        </div>
                      </div>

                      <div className="row mt-3">
                        <div className="col-3"> </div>
                        <div className="col-9">
                          <div className="row">
                            <div className="col-5">
                              <label className="labeaddjob">
                                {
                                  this.state.data_translate[
                                  Cookies.get("locale")
                                  ]["location_name"]
                                }
                              </label>
                              <br />
                              <input
                                type="text"
                                className="inputfile"
                                style={{ width: "100%" }}
                                name="location_name"
                                onChange={this.handleInputChange}
                                disabled={
                                  this.state.ckasset == true ? "" : "disabled"
                                }
                                value={this.state.location_name}
                              ></input>
                              <br />
                              <div className="row mt-2">
                                <div className="col-6">
                                  <label className="labeaddjob">
                                    {
                                      this.state.data_translate[
                                      Cookies.get("locale")
                                      ]["lat"]
                                    }
                                  </label>

                                  <br />
                                  <input
                                    type="text"
                                    className="inputfile"
                                    style={{ width: "100%" }}
                                    name="location_lat"
                                    onChange={this.handleInputChange}
                                    disabled={
                                      this.state.ckasset == true
                                        ? ""
                                        : "disabled"
                                    }
                                    //   value={this.state.location_lat}
                                    value={this.state.location_lat}
                                  ></input>
                                </div>
                                <div className="col-6">
                                  <label className="labeaddjob">
                                    {
                                      this.state.data_translate[
                                      Cookies.get("locale")
                                      ]["long"]
                                    }
                                  </label>

                                  <br />
                                  <input
                                    type="text"
                                    className="inputfile"
                                    style={{ width: "100%" }}
                                    name="location_lon"
                                    onChange={this.handleInputChange}
                                    disabled={
                                      this.state.ckasset == true
                                        ? ""
                                        : "disabled"
                                    }
                                    value={this.state.location_lon}
                                  ></input>
                                </div>
                              </div>
                            </div>
                            <div
                              className="col-4 ml-4 mt-3"
                              style={{ height: "200px" }}
                            >
                              <Map
                                data={{
                                  location_lat:
                                    this.state.location_lat === "-" ||
                                      this.state.location_lat === ""
                                      ? 13.8638
                                      : this.state.location_lat,
                                  location_lon:
                                    this.state.location_lon === "-" ||
                                      this.state.location_lon === ""
                                      ? 100.5998
                                      : this.state.location_lon,
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={
                    this.state.statusbtn == "2"
                      ? "card mt-2 divshow"
                      : "card mt-2 divhide"
                  }
                  style={{ width: "95%" }}
                >
                  <div className="card-body">
                    <div
                      className={
                        this.state.statusbtn == "2"
                          ? "mt-2 divshow"
                          : "mt-2  divhide"
                      }
                    >
                      <div className="row mt-3">
                        <div className="col-2"> </div>

                        <div className="col-10">
                          <img
                            style={{
                              float: "left",
                              marginTop: "7px",
                              marginRight: "10px",
                            }}
                            src={Api.absoluteUrl("/icon/alert.svg")}
                          />
                          <span className="jobdetail">
                            {
                              this.state.data_translate[Cookies.get("locale")][
                              "problem_detail"
                              ]
                            }
                          </span>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-3"> </div>
                        <div className="col-7">
                          <div className="row">
                            <div className="col-6">
                              {this.state.factupdate ? (
                                <label className="labeaddjob">
                                  {
                                    this.state.data_translate[
                                    Cookies.get("locale")
                                    ]["inform_date"]
                                  }
                                </label>
                              ) : null}
                              <br />
                              <DatePicker
                                className="datepicker"
                                defaultValue={moment(
                                  this.state.DateTime_Install,
                                  dateFormatList[0]
                                )}
                                format={dateFormatList}
                                onChange={(value) =>
                                  this.handleDateChange("date_install", value)
                                }
                                style={{ width: "90%" }}
                              />
                            </div>
                            <div className="col-6">
                              {this.state.factupdate ? (
                                <label className="labeaddjob">
                                  {
                                    this.state.data_translate[
                                    Cookies.get("locale")
                                    ]["inform_name"]
                                  }
                                </label>
                              ) : null}
                              <br />
                              <input
                                type="text"
                                className="inputfile"
                                style={{ width: "100%", padding: "5px" }}
                                onChange={(e) =>
                                  this.setState({ inform_name: e.target.value })
                                }
                                name="inform_name"
                                value={this.state.inform_name}
                              ></input>
                            </div>
                            <div className="col-6 mt-2 divhide">
                              {this.state.factupdate ? (
                                <label className="labeaddjob">
                                  {
                                    this.state.data_translate[
                                    Cookies.get("locale")
                                    ]["assign_date"]
                                  }
                                </label>
                              ) : null}
                              <br />
                              <DatePicker
                                className="datepicker"
                                defaultValue={moment(
                                  this.state.Assign_date,
                                  dateFormatList[0]
                                )}
                                format={dateFormatList}
                                onChange={(value) =>
                                  this.handleDateChange(
                                    "last_assign_date",
                                    value
                                  )
                                }
                                style={{ width: "90%" }}
                              />
                            </div>
                            <div className="col-6 mt-2">
                              {this.state.factupdate ? (
                                <label className="labeaddjob">
                                  {
                                    this.state.data_translate[
                                    Cookies.get("locale")
                                    ]["ma_period"]
                                  }
                                </label>
                              ) : null}
                              <br />
                              <Select
                                style={{ width: "94%" }}
                                value={form["ma_period_id"]}
                                className="dropdrowtype"
                                onChange={(value) =>
                                  this.handleSelectChange("ma_period_id", value)
                                }
                              >
                                {this.state.get_preiod.map((item, index) => (
                                  <Select.Option
                                    key={index}
                                    value={item.ma_period_id}
                                  >
                                    {item.ma_time_start}
                                    {" - "}
                                    {item.ma_time_end}
                                  </Select.Option>
                                ))}
                              </Select>
                            </div>
                            <div className="col-6 mt-2">
                              {this.state.factupdate ? (
                                <label
                                  className="labeaddjob font-thai-r"
                                  style={{ fontSize: "18px" }}
                                >
                                  {
                                    this.state.data_translate[
                                    Cookies.get("locale")
                                    ]["plan_start_end"]
                                  }
                                </label>
                              ) : null}
                              <br />{" "}
                              <RangePicker
                                defaultValue={this.state.plan_date.length === 0 ? "" : [moment(this.state.plan_date[0], dateFormat), moment(this.state.plan_date[1], dateFormat)]}
                                onChange={(e) =>
                                  this.setState({
                                    plan_date: e
                                  })
                                }
                                style={{ color: "#000F9F", width: "95%" }}
                                name="date"
                              />
                            </div>

                          </div>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-3"> </div>
                        <div className="col-7">
                          <div className="row">
                            <div className="col-12">
                              {this.state.factupdate ? (
                                <label className="labeaddjob">
                                  {
                                    this.state.data_translate[
                                    Cookies.get("locale")
                                    ]["inform_detail"]
                                  }
                                </label>
                              ) : null}
                              <br />
                              <textarea
                                style={{ width: "100%", height: "80px" }}
                                name="inform_detail"
                                defaultValue={this.state.form["inform_detail"]}
                                onChange={this.handleInputChange}
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-3"> </div>
                        <div className="col-7">
                          <div className="row">
                            <div className="col-12">
                              {this.state.factupdate ? (
                                <label className="labeaddjob">
                                  {
                                    this.state.data_translate[
                                    Cookies.get("locale")
                                    ]["remark"]
                                  }
                                </label>
                              ) : null}
                              <br />
                              <textarea
                                style={{ width: "100%", height: "80px" }}
                                name="remark"
                                defaultValue={this.state.form["remark"]}
                                onChange={this.handleInputChange}
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3 ">
                        <div className="col-3"> </div>
                        <div className="col-7">
                          <div className="row">
                            <div className="col-6">
                              {this.state.factupdate ? (
                                <label className="labeaddjob">
                                  Object Part
                                  <b style={{ color: "#DF4547" }}>*</b>
                                </label>
                              ) : null}
                              <Select
                                style={{ width: "100%" }}
                                className="dropdrowtype"
                                onChange={(value) =>
                                  this.handleproblem("objectpart", value)
                                }
                                value={
                                  this.state.customs.select_object_path || ""
                                }
                              >
                                <Select.Option value="" disabled>
                                  Please select
                                </Select.Option>
                                {this.state.ObjectPart.map((item, index) => (
                                  <Select.Option
                                    key={index}
                                    value={item.service_type_level_id || ""}
                                  >
                                    {item.service_desc}
                                  </Select.Option>
                                ))}
                              </Select>
                              {this.state.valid_obj_part === false &&
                                this.state.valid === true ? (
                                <b
                                  className="labeaddjob mt-4"
                                  style={{ color: "#DF4547" }}
                                >
                                  กรุณาเลือก Object Part
                                </b>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-6">
                              {this.state.factupdate ? (
                                <label className="labeaddjob">
                                  Service Type{" "}
                                  <b style={{ color: "#DF4547" }}>*</b>
                                </label>
                              ) : null}
                              <Select
                                style={{ width: "100%" }}
                                className="dropdrowtype"
                                onChange={(value) =>
                                  this.handleproblem("servicetype", value)
                                }
                                value={this.state.sel_type || ""}
                              >
                                <Select.Option value="" disabled>
                                  Please select
                                </Select.Option>
                                {this.state.serviceType.map((item, index) => (
                                  <Select.Option
                                    key={index}
                                    value={item.service_type_level_id || ""}
                                  >
                                    {item.service_desc}
                                  </Select.Option>
                                ))}
                              </Select>
                              {this.state.valid_service_type === false &&
                                this.state.valid === true ? (
                                <b
                                  className="labeaddjob mt-4"
                                  style={{ color: "#DF4547" }}
                                >
                                  กรุณาเลือก Service Type
                                </b>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3 ">
                        <div className="col-3"> </div>
                        <div className="col-7">
                          <div className="row">
                            <div className="col-6">
                              {this.state.factupdate ? (
                                <label className="labeaddjob">
                                  Category Type{" "}
                                  <b style={{ color: "#DF4547" }}>*</b>
                                </label>
                              ) : null}
                              <Select
                                style={{ width: "100%" }}
                                defaultValue=""
                                className="dropdrowtype"
                                value={this.state.sel_new_type || ""}
                                onChange={(value) =>
                                  this.handleproblem("new_type", value)
                                }
                              >
                                <Select.Option value="" disabled>
                                  Please select
                                </Select.Option>
                                {this.state.newType.map((item, index) => (
                                  <Select.Option
                                    key={index}
                                    value={item.service_type_level_id || ""}
                                  >
                                    {this.state.checkAssetType === true
                                      ? item.service_desc
                                      : item.service_LV3_name}
                                  </Select.Option>
                                ))}
                              </Select>
                              {this.state.valid_new_type === false &&
                                this.state.valid === true ? (
                                <b
                                  className="labeaddjob mt-4"
                                  style={{ color: "#DF4547" }}
                                >
                                  กรุณาเลือก Service Type
                                </b>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-6">
                              {this.state.factupdate ? (
                                <label className="labeaddjob">
                                  Sub Category{" "}
                                  <b style={{ color: "#DF4547" }}>*</b>
                                </label>
                              ) : null}
                              <Select
                                style={{ width: "100%" }}
                                className="dropdrowtype"
                                value={this.state.sel_sub_cat || ""}
                                onChange={(value) =>
                                  this.handleproblem("sub_category", value)
                                }
                              >
                                <Select.Option value="" disabled>
                                  Please select
                                </Select.Option>
                                {this.state.subCategory.map((item, index) => (
                                  <Select.Option
                                    key={index}
                                    value={item.service_type_level_id || ""}
                                  >
                                    {this.state.checkAssetType === true
                                      ? item.service_desc
                                      : item.service_LV4_name}
                                  </Select.Option>
                                ))}
                              </Select>
                              {this.state.valid_sub_cat === false &&
                                this.state.valid === true ? (
                                <b
                                  className="labeaddjob mt-4"
                                  style={{ color: "#DF4547" }}
                                >
                                  กรุณาเลือก Sub Category
                                </b>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3 ">
                        <div className="col-3"> </div>
                        <div className="col-7">
                          <div className="row">
                            <div className="col-3">
                              {this.state.factupdate ? (
                                <label className="labeaddjob">SLA Level</label>
                              ) : null}
                              <Select
                                style={{ width: "100%" }}
                                className="dropdrowtype"
                                value={this.state.sel_sla || ""}
                                onChange={(value) =>
                                  this.handleproblem("sla", value)
                                }
                              >
                                <Select.Option value="" disabled>
                                  Please select

                                </Select.Option>
                                {this.state.sla_level.map((item, index) => (
                                  <Select.Option
                                    key={index}
                                    value={item.job_sla_id}
                                  >
                                    {item.sla_name}
                                  </Select.Option>
                                ))}
                              </Select>
                            </div>
                            <div className="col-3">
                              {this.state.factupdate ? (
                                <label className="labeaddjob">
                                  Standard Day
                                </label>
                              ) : null}
                              <input
                                disabled
                                type="text"
                                className="inputfile"
                                style={{ width: "100%", padding: "5px" }}
                                name="inform_name"
                                value={this.state.std_day}
                              ></input>
                            </div>
                            <div className="col-3">
                              {this.state.factupdate ? (
                                <label className="labeaddjob">
                                  Standard Hour
                                </label>
                              ) : null}
                              <input
                                disabled
                                type="text"
                                className="inputfile"
                                style={{ width: "100%", padding: "5px" }}
                                name="inform_name"
                                value={this.state.std_hour}
                              ></input>
                            </div>
                            <div className="col-3">
                              {this.state.factupdate ? (
                                <label className="labeaddjob">
                                  Standard Minute
                                </label>
                              ) : null}
                              <input
                                disabled
                                type="text"
                                className="inputfile"
                                style={{ width: "100%", padding: "5px" }}
                                name="inform_name"
                                value={this.state.minute}
                              ></input>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3 ">
                        <div className="col-3"> </div>
                        <div className="col-7">
                          <div className="row">
                            <div className="col-6 divhide">
                              {this.state.factupdate ? (
                                <label className="labeaddjob">
                                  {
                                    this.state.data_translate[
                                    Cookies.get("locale")
                                    ]["inform_name"]
                                  }
                                </label>
                              ) : null}
                              <br />
                              <input
                                type="text"
                                className="inputfile"
                                style={{ width: "100%", padding: "5px" }}
                                name="inform_name"
                                onChange={this.handleInputChange}
                              ></input>
                              <br />
                            </div>
                            <div className="col-12">
                              {this.state.factupdate ? (
                                <label className="labeaddjob">
                                  {
                                    this.state.data_translate[
                                    Cookies.get("locale")
                                    ]["priority"]
                                  }
                                </label>
                              ) : null}
                              {/* <br /> */}
                              <Radio.Group
                                onChange={this.onChangePriority}
                                value={this.state.Priority}
                              >
                                <Radio value={3} className="ml-5">
                                  <img
                                    src={Api.absoluteUrl("/icon/high.svg")}
                                    style={{
                                      marginLeft: "10px",
                                    }}
                                    className="mr-2"
                                  />
                                </Radio>
                                <Radio value={2} className="mt-2">
                                  <img
                                    src={Api.absoluteUrl("/icon/normal.svg")}
                                    style={{
                                      marginLeft: "10px",
                                    }}
                                    className="mr-2"
                                  />
                                </Radio>
                                <Radio value={1} className="mt-2">
                                  <img
                                    src={Api.absoluteUrl("/icon/low.svg")}
                                    className="mr-2"
                                    style={{
                                      marginLeft: "10px",
                                    }}
                                  />
                                </Radio>
                              </Radio.Group>
                            </div>
                          </div>
                        </div>
                        <div
                          className="col-2"
                          style={{ textAlign: "center" }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={
                    this.state.statusbtn == "2"
                      ? "card mt-2 divshow"
                      : "card mt-2 divhide"
                  }
                  style={{ width: "95%", display: "none" }}
                >
                  <div className="card-body">
                    <div
                      className={
                        this.state.statusbtn == "2"
                          ? "mt-2 divshow"
                          : "mt-2  divhide"
                      }
                    >
                      <div className="row mt-3">
                        <div className="col-2"> </div>

                        <div className="col-10">
                          <img
                            style={{
                              float: "left",
                              marginTop: "7px",
                              marginRight: "10px",
                            }}
                            src={Api.absoluteUrl("/icon/alert.svg")}
                          />
                          <span className="jobdetail"> MA Service </span>
                        </div>
                      </div>

                      <div className="row mt-3">
                        <div className="col-3"> </div>

                        <div className="col-9">
                          <Checkbox
                            onChange={this.checkboxTeam}
                            checked={this.state.ckTeam}
                            style={{ fontSize: "20px", color: "#0500A3" }}
                          >
                            Team
                          </Checkbox>
                          <Checkbox
                            onChange={this.checkboxSingle}
                            checked={this.state.ckSingle}
                            style={{ fontSize: "20px", color: "#0500A3" }}
                            className="ml-5"
                          >
                            Single
                          </Checkbox>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-3"> </div>
                        <div className="col-9">
                          <div className="row">
                            <div
                              className={
                                this.state.ckTeam == true
                                  ? "divshow col-3"
                                  : "divhide col-3"
                              }
                            >
                              <label className="labeaddjob mt-3">
                                MA team group
                                <b style={{ color: "#DF4547" }}>*</b>
                              </label>
                              <br />
                              <input type="text" className="inputfile"></input>
                            </div>
                            <div
                              className={
                                this.state.ckTeam == true
                                  ? "divshow col-3"
                                  : "divhide col-3"
                              }
                            >
                              <label className="labeaddjob mt-3">
                                MA Team <b style={{ color: "#DF4547" }}>*</b>
                              </label>
                              <br />
                              <input type="text" className="inputfile"></input>
                            </div>
                            <div
                              className={
                                this.state.ckSingle == true
                                  ? "divshow col-3"
                                  : "divhide col-3"
                              }
                            >
                              <label className="labeaddjob mt-3">
                                Skill <b style={{ color: "#DF4547" }}>*</b>
                              </label>
                              <br />
                              <input type="text" className="inputfile"></input>
                            </div>
                            <div
                              className={
                                this.state.ckSingle == true
                                  ? "divshow col-3"
                                  : "divhide col-3"
                              }
                            >
                              <label className="labeaddjob mt-3">
                                Employee <b style={{ color: "#DF4547" }}>*</b>
                              </label>
                              <br />
                              <input type="text" className="inputfile"></input>
                            </div>
                          </div>
                          <div className="row">
                            <div
                              className={
                                this.state.ckTeam == true
                                  ? "divshow col-3"
                                  : "divhide col-3"
                              }
                            >
                              <label className="labeaddjob mt-3">
                                Work date
                              </label>
                              <br />
                              <input type="text" className="inputfile"></input>
                            </div>
                            <div
                              className={
                                this.state.ckTeam == true
                                  ? "divshow col-3"
                                  : "divhide col-3"
                              }
                            >
                              <label className="labeaddjob mt-3">
                                Finish date
                              </label>
                              <br />
                              <input type="text" className="inputfile"></input>
                            </div>
                            <div
                              className={
                                this.state.ckSingle == true
                                  ? "divshow col-3"
                                  : "divhide col-3"
                              }
                            >
                              <label className="labeaddjob mt-3">
                                Work date
                              </label>
                              <br />
                              <input type="text" className="inputfile"></input>
                            </div>
                            <div
                              className={
                                this.state.ckSingle == true
                                  ? "divshow col-3"
                                  : "divhide col-3"
                              }
                            >
                              <label className="labeaddjob mt-3">
                                Finish date
                              </label>
                              <br />
                              <input type="text" className="inputfile"></input>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={
                    this.state.statusbtn == "2"
                      ? "card mt-2 divshow"
                      : "card mt-2 divhide"
                  }
                  style={{ width: "95%" }}
                >
                  <div className="card-body">
                    <div
                      className={
                        this.state.statusbtn == "2"
                          ? "mt-2 divshow"
                          : "mt-2  divhide"
                      }
                    >
                      <div className="row mt-3">
                        <div className="col-2"> </div>

                        <div className="col-10">
                          <img
                            style={{
                              float: "left",
                              marginTop: "7px",
                              marginRight: "10px",
                            }}
                            src={Api.absoluteUrl("/icon/photo-camera.svg")}
                          />

                          <span className="jobdetail">
                            {
                              this.state.data_translate[Cookies.get("locale")][
                              "photo"
                              ]
                            }
                          </span>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-2"></div>
                        <div className="col-10 mb-5">
                          <div style={{ textAlign: "center" }} className="mt-5">
                            <div>
                              {JSON.parse(localStorage.getItem("StatusLocal")) === 1 ?
                                <>
                                  <div className="row mb-2 ">
                                    <div className="col-10" style={{ border: "1px solid #c9c1c1", padding: "15px" }}>
                                      <div className="row">
                                        {this.state.set_pic.map((data, index) => {
                                          return (
                                            <>

                                              {(data.pic_upload_type.toLowerCase() === ".jpg" ||
                                                data.pic_upload_type.toLowerCase() === ".png" ||
                                                data.pic_upload_type.toLowerCase() === ".jpeg" ||
                                                data.pic_upload_type.toLowerCase() === ".svg") &&
                                                (data.pic_type === "O" || data.pic_type === "N") ? (
                                                <div class="col-auto mb-2">

                                                  <Image
                                                    className="ml-1"
                                                    style={{ cursor: "pointer" }}
                                                    width={150}
                                                    height={80}
                                                    src={Api.checkPath(
                                                      data.pic_url_path,
                                                      data.pic_upload_name
                                                    )}
                                                  />
                                                </div>
                                              ) : (data.pic_upload_type.toLowerCase() === ".mp4" ||
                                                data.pic_upload_type.toLowerCase() === ".avi" ||
                                                data.pic_upload_type.toLowerCase() === ".mov" ||
                                                data.pic_upload_type.toLowerCase() === ".wmv") &&
                                                (data.pic_type === "O" || data.pic_type === "N") ? (
                                                <div class="col-auto mb-1">
                                                  <video
                                                    width="150"
                                                    controls
                                                    className="ml-1  mr-1"
                                                    style={{ height: "80px" }}
                                                  >
                                                    <source
                                                      src={Api.checkPath(
                                                        data.pic_url_path,
                                                        data.pic_upload_name
                                                      )}
                                                      type="video/mp4"
                                                    ></source>
                                                  </video>
                                                </div>
                                              ) : (data.pic_upload_type.toLowerCase() === ".pdf" ||
                                                data.pic_upload_type.toLowerCase() === ".xlsx" ||
                                                data.pic_upload_type.toLowerCase() === ".xls" ||
                                                data.pic_upload_type.toLowerCase() === ".doc" ||
                                                data.pic_upload_type.toLowerCase() === ".txt") &&
                                                (data.pic_type === "O" || data.pic_type === "N") ? (
                                                <div class="col-auto mb-1">
                                                  <a
                                                    href={Api.checkPath(
                                                      data.pic_url_path,
                                                      data.pic_upload_name
                                                    )}

                                                    download>
                                                    <CopyOutlined style={{ marginRight: "5px" }} />

                                                    {data.pic_upload_name}
                                                  </a>
                                                </div>
                                              ) : null}
                                            </>
                                          );
                                        })}

                                        <Upload
                                          action={process.env.REACT_APP_URL_API + "mockupupload/"}
                                          multiple={true}
                                          listType="picture-card"
                                          fileList={fileList}
                                          onPreview={this.handlePreview}
                                          onChange={this.handleChange}
                                          height={"20%"}
                                        >
                                          {this.state.btnName === "Create Job"
                                            ? null
                                            : fileList.length >= 8
                                              ? null
                                              : uploadButton}
                                        </Upload>
                                      </div>

                                    </div>
                                  </div>
                                </>
                                :
                                <div className="row mt-2">
                                  <div className="col-3"></div>
                                  <div className="col-9">
                                    <div className="row">
                                      {this.state.set_pic.map((data, index) => {
                                        return (
                                          <>
                                            {(data.pic_upload_type.toLowerCase() === ".jpg" ||
                                              data.pic_upload_type.toLowerCase() === ".png" ||
                                              data.pic_upload_type.toLowerCase() === ".jpeg" ||
                                              data.pic_upload_type.toLowerCase() === ".svg") &&
                                              data.pic_type === "N" ? (
                                              <div class="col-auto mb-1">
                                                <Image
                                                  className="ml-1"
                                                  style={{ cursor: "pointer" }}
                                                  width={150}
                                                  height={80}
                                                  src={Api.checkPath(
                                                    data.pic_url_path,
                                                    data.pic_upload_name
                                                  )}
                                                />
                                              </div>
                                            ) : (data.pic_upload_type.toLowerCase() === ".mp4" ||
                                              data.pic_upload_type.toLowerCase() === ".avi" ||
                                              data.pic_upload_type.toLowerCase() === ".mov" ||
                                              data.pic_upload_type.toLowerCase() === ".wmv") &&
                                              data.pic_type === "N" ? (
                                              <div class="col-auto mb-1">
                                                <video
                                                  width="150"
                                                  controls
                                                  className="ml-1  mr-1"
                                                  style={{ height: "80px" }}
                                                >
                                                  <source
                                                    src={Api.checkPath(
                                                      data.pic_url_path,
                                                      data.pic_upload_name
                                                    )}
                                                    type="video/mp4"
                                                  ></source>
                                                </video>
                                              </div>
                                            ) : (data.pic_upload_type.toLowerCase() === ".pdf" ||
                                              data.pic_upload_type.toLowerCase() === ".xlsx" ||
                                              data.pic_upload_type.toLowerCase() === ".xls" ||
                                              data.pic_upload_type.toLowerCase() === ".doc" ||
                                              data.pic_upload_type.toLowerCase() === ".txt") &&
                                              data.pic_type === "N" ? (
                                              <div class="col-auto mb-1">
                                                <a
                                                  href={Api.checkPath(
                                                    data.pic_url_path,
                                                    data.pic_upload_name
                                                  )}

                                                  download>
                                                  <CopyOutlined style={{ marginRight: "5px" }} />

                                                  {data.pic_upload_name}
                                                </a>
                                              </div>

                                            ) : null}
                                          </>
                                        );
                                      })}
                                    </div>

                                  </div>
                                  <Upload
                                    action={process.env.REACT_APP_URL_API + "mockupupload/"}
                                    multiple={true}
                                    listType="picture-card"
                                    fileList={fileList}
                                    onPreview={this.handlePreview}
                                    onChange={this.handleChange}
                                    height={"20%"}
                                  >
                                    {fileList.length >= 8
                                      ? null
                                      : uploadButton}
                                  </Upload>
                                  <Modal
                                    visible={this.state.previewVisible}
                                    title={this.state.previewTitle}
                                    footer={null}
                                    onCancel={this.handleCancel}
                                  >
                                    <img
                                      alt="example"
                                      style={{ width: "100%" }}
                                      src={Api.absoluteUrl(this.state.previewImage)}
                                    />
                                  </Modal>
                                </div>
                              }


                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{ textAlign: "center" }}
              className={
                this.state.statusbtn == "2"
                  ? "mt-3 mb-3 divshow"
                  : "mt-3 mb-3 divhide"
              }
            >
              {this.state.checkbtn ? (
                <button
                  type="button"
                  className="btnbrows"
                  disabled={this.state.disabled_btn}
                  style={this.state.disabled_btn === true ? {
                    cursor: "no-drop",
                    background: "#c8c8c6 0 0 no-repeat padding-box",
                    color: "#ffffff"
                  } : {
                    cursor: "pointer",
                    background: "#e8cd00 0 0 no-repeat padding-box",
                    color: "#000f9f"
                  }}
                  onClick={() => this.handleSubmit()}
                >
                  <span style={{ fontSize: "16px" }}>Submit</span>
                </button>
              ) : (
                <b style={{ color: "red" }}>
                  {this.state.status_button_workflow}
                </b>
              )}
            </div>
            <div></div>
          </>
        ) : null}
        <div style={{ height: "30px" }}></div>
      </LayoutOperation>
    );
  }
}
const mapStateToProps = (state) => ({
  lang: state.lang,
  dynamicReducer: state.dynamicReducer,
});
const mapDispacthToProps = (dispatch) => {
  return {
    changeLang: (data) => dispatch(changeLang(data)),
    setDynamic: (data, visible) => dispatch(setDynamic(data, visible)),
  };
};

export default connect(mapStateToProps, mapDispacthToProps)(Editjob);
